import { type FC, type JSX, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  Accordion,
  AccordionDetails,
  AccordionStack,
  AccordionSummary,
  Link,
} from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { urlResolverGetFaq } from '../../../url-handling'

import { NfcLandingPageFaqData } from './NfcLandingPageFaqData'

export const NfcLandingPageFaqAccordion: FC = () => {
  const globalConfig = useGlobalConfigContext()

  const anchor = (text: ReactNode[]): JSX.Element => (
    <Link href={urlResolverGetFaq(globalConfig)}>{text}</Link>
  )

  return (
    <div className="flex flex-col gap-4">
      <AccordionStack>
        {NfcLandingPageFaqData.map(({ details, key, summary }) => (
          <Accordion
            itemProp="mainEntity"
            itemScope
            itemType="https://schema.org/Question"
            key={key}
          >
            <AccordionSummary itemProp="name">{summary}</AccordionSummary>
            <AccordionDetails
              className="prose"
              itemProp="acceptedAnswer"
              itemScope
              itemType="https://schema.org/Answer"
            >
              <div itemProp="text">{details}</div>
            </AccordionDetails>
          </Accordion>
        ))}
      </AccordionStack>

      <div className="px-2 text-s font-medium" id="nfc-faq-link">
        <FormattedMessage
          id="nfc.faq.findMoreAnswer.link"
          values={{
            anchor,
          }}
        />
      </div>
    </div>
  )
}
